import {createI18n} from 'vue-i18n';
import {getLocale} from '../core/Utils';
import messagesEn from './en.yml';
import messagesFr from './fr.yml';

const messages = {
  en: messagesEn,
  fr: messagesFr,
};

const i18n = createI18n({
  locale: getLocale(),
  messages,
});

export default i18n;
